import { createContext } from 'react';
export const OpenPopupContext = /*#__PURE__*/createContext({
  positionChannel: null
});